module.exports = "/_next/static/images/clock-line-a509230ac3ae4b965bd749b9217997b2.svg";